import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

const getStoredTheme = () => {
  const app = localStorage.getItem('app_theme');
  if (app === 'light' || app === 'dark') return app;
  const legacy = localStorage.getItem('theme');
  if (legacy === 'light-theme') return 'light';
  if (legacy === 'dark-theme') return 'dark';
  return 'dark';
};

const persistTheme = (newTheme) => {
  localStorage.setItem('app_theme', newTheme);
  localStorage.setItem('theme', newTheme === 'light' ? 'light-theme' : 'dark-theme');
};

const applyThemeToDom = (newTheme) => {
  const root = document.documentElement;
  const appElement = document.querySelector('.App');

  root.classList.remove('dark-theme', 'light-theme');
  document.body.classList.remove('dark-theme', 'light-theme');
  if (appElement) {
    appElement.classList.remove('dark-theme', 'light-theme');
  }

  if (newTheme === 'light') {
    root.classList.add('light-theme');
    document.body.classList.add('light-theme');
    if (appElement) {
      appElement.classList.add('light-theme');
    }
  } else {
    root.classList.add('dark-theme');
    document.body.classList.add('dark-theme');
    if (appElement) {
      appElement.classList.add('dark-theme');
    }
  }
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(getStoredTheme);

  useEffect(() => {
    applyThemeToDom(theme);
  }, [theme]);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    persistTheme(newTheme);
    setTheme(newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

